<template>

  <h2 style="margin-top: -35px;">PhotoProv Admin App</h2>
  <div class="label" style="margin-top:-8px;">{{ userEmail }}</div>

  <div v-if="displayLogin">
    <div style="padding-left:10px;">
      With this web app you can... <br>
      <ol>
        <li>Set up/Manage performances</li>
        <li>Generate QR code for audience web app </li>
        <li>Approve/Reject audience uploaded images </li>
      </ol>
    </div>

    <br>

    <CognitoLogin />
  </div>


  <h3 class="error" v-if="errorMsg">{{ errorMsg }}</h3>

  <div v-if="fetchingDataFromServer" style="text-align: center; margin-top: 20px; max-width: 550px;">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
    <p style="font-style: italic;">One Moment Please</p>
  </div>

  <br>

  <ShowsList v-if="userIsAdmin && !displayShowDetails" :shows="shows" :idToken="idToken" @refresh-shows="onRefreshShows"
    @show-modified="onShowModified" />

  <br>
  <hr>
  <span class="label">PhotoProv©2025</span>
</template>

<script>
import { userManager } from '../../photo-prov-shared/lib/classes/cognitoAuth.mjs';
import { pProvShow } from "../../photo-prov-shared/lib/classes/pprovShow.mjs"
import CognitoLogin from '../../photo-prov-shared/lib/components/CognitoLogin.vue';
import ShowsList from './components/ShowsList.vue';

export default {
  name: 'App',
  components: {
    CognitoLogin,
    ShowsList
  },
  data() {
    return {
      shows: [],
      displayLogin: false,
      displayShowDetails: false,
      userIsAdmin: false,
      errorMsg: null,
      accessToken: null,
      idToken: null,
      userEmail: null,
      fetchingDataFromServer: false,
    }
  },
  created() {
    // old hardcoded show data (now comes from server)
    /* 
    this.shows = [
      new pProvShow(
        {
          id: uuid(),
          showDate: "2025-04-07",
          venue: "Comedy Sportz, NYC"
        })];
    */
  },
  mounted() {
    // debug...
    console.log(`VUE_APP_ADMIN_AUTH_CALLBACK_URI: ${process.env.VUE_APP_ADMIN_AUTH_CALLBACK_URI}`);

    // userManager is used to process OIDC callback is not yet initialized (hidden iFrame?, etc.) at this point
    // so we need to use a timeout. i.e., avoid  "Cannot access 'userManager' before initialization" error
    // (kind of a hack - TODO: better way to handle this?)
    setTimeout(() => {
      this.checkAuth(this);
    }, 200);

  },
  methods: {
    onShowModified() {
      // when existing show data is modified or a new show is added
      // data will have already been persisted on the back end by ShowDetails component
      // therefore we just have to refresh data from the server
      // (this requires an additional call to server backend but is worth it for code simplicity
      // and reduced risk of possible defects where local data doesn't match what's on the server)
      this.getShowsData(this);
    },
    onRefreshShows() {
      this.getShowsData(this);
    },
    async getShowsData(myThis) {
      myThis.fetchingDataFromServer = true;

      // bit of a hack... when getShowsData gets called in the context of a timer callback, 
      // "this" needs to be passed in.
      const authToken = myThis.idToken;
      const apiEndpoint = process.env.VUE_APP_PRV_API + '/shows';

      try {
        const response = await fetch(apiEndpoint, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${authToken}`,
          }
        });

        if (!response.ok) {
          // Handle HTTP errors (e.g., 4xx, 5xx)
          const errorText = await response.text(); // Get error details if available
          console.error('Fetch error:', response.status, errorText);
          throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
        }

        const data = await response.json(); // Parse the JSON response body
        // debug...
        console.log(`fetch from ${apiEndpoint}\nresponse data:\n`, data);
        // sort array of shows by showDate ascending
        data.sort((a, b) => new Date(a.showDate) - new Date(b.showDate));

        // convert JSON to pProvShow objects
        var showsData = data.map(item => new pProvShow(item));
        myThis.shows = showsData; // Update the component's data

        myThis.errorMsg = null; // Clear previous errors on success

      } catch (error) {
        // Handle network errors or errors during fetch/parsing
        console.error('Error fetching data:', error);
        myThis.errorMsg = 'Error getting data from server';
        myThis.shows = []; // Clear shows data on error
      } finally {
        myThis.fetchingDataFromServer = false;
      }

    },

    checkAuth(myThis) {
      // check session state first 
      const adminUserEmail = sessionStorage.getItem('ADMIN_USER_EMAIL');
      if (adminUserEmail) {
        // on page refresh, prevent going back to login page
        myThis.displayLogin = false;
        myThis.userIsAdmin = true;
        myThis.errorMsg = null;
        myThis.userEmail = adminUserEmail;
        myThis.getShowsData(myThis);
        return;
      }

      // check to see if we're handling the callback after sign in
      // (look for code= query param)
      const queryString = window.location.search; // e.g., "?code=12345&state=xyz"
      const urlParams = new URLSearchParams(queryString);
      const authCode = urlParams.get('code');
      // const authState = urlParams.get('state');

      if (!authCode) {
        this.displayLogin = true;
        this.userIsAdmin = false;
      }
      else {

        userManager.signinCallback()
          .then(function (user) {
            // debug... console.log('signinCallback - user:\n', user);
            // this is method is called from a timeout callback so we need to use this myThis hack
            myThis.displayLogin = false;
            myThis.userIsAdmin = true;
            myThis.errorMsg = null;
            myThis.accessToken = user.access_token;
            myThis.idToken = user.id_token;
            myThis.userEmail = user.profile.email;
            // debug... console.log(`authenticated user email: ${myThis.userEmail}`);
            // debug... console.log(`access token: ${myThis.accessToken}`);
            console.log(`id token: ${myThis.idToken}`);

            // save login in session state (to be checked on page refresh)
            sessionStorage.setItem('ADMIN_USER_EMAIL', user.profile.email);

            // now that user is authenticated and we have the auth token
            // we can now fetch shows data from the server
            myThis.getShowsData(myThis); // Call the updated fetch-based method

          })
          .catch(function (error) {
            // an error will occur (HTTP 400) if Google user is signed in
            // but is not a member of the photoProvAdmins group
            console.log('signinCallback - error:\n', error);
            myThis.displayLogin = true;
            myThis.userIsAdmin = false;
            myThis.errorMsg = "Google user does not have admin permissions";
          });
      }

    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 60px;

}

#logo {
  display: flex;
  width: 15%;
  flex-direction: column;
  justify-content: center;
  margin: auto;
}

.form-section {
  display: block;
  margin: 2%;
  justify-content: left;
}

.error {
  color: red;
}

div {
  margin: 1%;
  /* border: 3px solid purple; */
}

input {
  margin: 1%;
  border: 1px solid black;
}

label {
  margin: 1%;
}

.label {
  color: grey;
  font-style: italic;
}

.buton-on-the-right {
  border: 0px solid purple;
  display: flex;
  /* Make it a flex container */
  justify-content: space-between;
  /* Push items to opposite ends */
  align-items: bottom;
  padding-right: 1%;
  /* Add some padding so button isn't flush right */
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 0px dashed blue;
}
</style>
